<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <h2 class="mt-lg-4" style="font-family: OpenSans-bold; margin-bottom: -10px;">
      <strong>{{ titleSection }}</strong>
    </h2>
    <!--Section: Horizontal stepper-->
    <section class="my-5">
      <!--Card-->
      <mdb-card class="card-person-width" cascade>
        <!--Card image-->
        <div
          class="price white-text rounded-top"
          v-bind:style="{padding: '1rem 2rem', textAlign: 'left', background: '#026ab4', fontFamily: 'OpenSans-Regular', fontSize: '16px', lineHeight: '1.38'}"
        >
          <span>
            <img
              alt="icono calendario"
              :src="imgServer+'apps/myfrac/admin/assets/Calendar_icon@3x.png'"
              class="img-fluid"
              style="width: 28px; height: 26px"
            />
          </span>
          &nbsp; {{ titleSection }}
          <div class="text-right" style=" margin-top: -10px; margin-right: -20px; float: right;">
            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
              <span slot="tip">Descartar evento</span>
              <mdb-btn
                slot="reference"
                outline="white"
                rounded
                size="sm"
                class="px-2 style_BTN"
                @click="removeEvent"
              >
                <mdb-icon icon="times" class="mt-0" />
              </mdb-btn>
            </mdb-tooltip>
          </div>
        </div>

        <!--/Card image-->

        <!--Card content-->
        <mdb-card-body>
          <div class="save-btn">
            <mdb-col>
              <mdb-row>
                <label>
                  Guardar y salir
                  <a slot="reference" @click="saveAndExit">
                    <img
                      alt="guardar y salir"
                      :src="imgServer+'apps/myfrac/admin/assets/Save_BTN@3x.png'"
                      class="img-fluid"
                      style="width: 19.6px; height: 19.6px; margin-left: 7px;"
                    />
                  </a>
                </label>
              </mdb-row>
            </mdb-col>
          </div>
          <mdb-stepper
            within
            buttons
            nextBtn="Siguiente"
            prevBtn="Atrás"
            submitBtn="Finalizar"
            :submitFunction="saveStep2"
            validation
            :validatedSteps="validatedSteps"
            @validate="validate"
          >
            <mdb-step :name="titleSection" slot="content" :number="1">
              <mdb-row v-bind:style="{marginRight: '-8%'}">
                <mdb-col md="5">
                  <mdb-card-body>
                    <mdb-row>
                      <mdb-col md="6">
                        <div class="form-group">
                          <label
                            for="eventTitle"
                            style="font-family: OpenSans-Semibold; font-size: 12px"
                          >Título del evento *</label>
                          <input
                            type="text"
                            class="form-control text-input-2"
                            id="eventTitle"
                            required
                            placeholder="Título del evento"
                            maxlength="64"
                            v-model="form[0].title"
                            style="height: 37px; margin-top: 10px; font-size: 12px"
                          />
                        </div>
                      </mdb-col>
                    </mdb-row>
                    <mdb-row>
                      <mdb-col md="6">
                        <div class="form-group">
                          <label for="eventPlace" style="font-family: OpenSans-Semibold;">Lugar *</label>
                          <model-select
                            :options="commonAreas"
                            class="text-input-2"
                            v-model="placeModel"
                            v-bind:style="{height: '37px'}"
                            placeholder="Selecciona un lugar"
                            :isError="placeValid"
                            :isDisabled="commonAreaDisable"
                          ></model-select>
                        </div>
                      </mdb-col>
                    </mdb-row>
                    <mdb-row>
                      <mdb-col md="6">
                        <div class="form-group">
                          <label
                            for="eventUser"
                            style="font-family: OpenSans-Semibold;"
                          >Nombre del residente *</label>
                          <model-select
                            :options="residentsList"
                            class="text-input-2"
                            v-model="residentModel"
                            v-bind:style="{height: '37px'}"
                            placeholder="Selecciona un residente"
                            :isError="userValid"
                            :isDisabled="!isAdmin"
                          ></model-select>
                        </div>
                      </mdb-col>
                    </mdb-row>
                  </mdb-card-body>
                </mdb-col>
                <mdb-col md="6">
                  <mdb-card-body class="mb-5">
                    <mdb-row>
                      <mdb-col md="5" class="picker-input-responsive">
                        <div class="form-group">
                          <label for="datePicker" style="font-family: OpenSans-Semibold;">Fecha *</label>
                          <mdb-date-picker
                            id="datePicker"
                            outline
                            @getValue="getDateInputValue"
                            :option="optionsDate"
                            :validation="validationDate"
                            :isValid="dateValid"
                            v-model="form[0].datepicker"
                            :limit="limitDate"
                            v-bind:style="{ marginTop: '-12%', fontSize: '12px'}"
                          />
                        </div>
                      </mdb-col>
                      <mdb-col md="5" class="picker-input-responsive">
                        <div class="form-group">
                          <label for="timePicker" style="font-family: OpenSans-Semibold;">Hora *</label>
                          <mdb-time-picker
                            id="timePicker"
                            v-model="form[0].timepicker"
                            outline
                            @getValue="getTimeInputValue"
                            @focus="onFocus"
                            :hoursFormat="24"
                            v-bind:style="{ marginTop: '-12%', fontSize: '12px'}"
                          />
                        </div>
                      </mdb-col>
                    </mdb-row>
                    <mdb-row>
                      <mdb-col md="8">
                        <div class="form-group">
                          <label
                            for="description"
                            style="font-family: OpenSans-Semibold;"
                          >Información adicional</label>
                          <textarea
                            v-model="description"
                            v-on:keyup="countdown"
                            class="text-width"
                            rows="5"
                            maxlength="200"
                            style="height: 100px; resize: none; border: solid 1px #e8e9ec;"
                          ></textarea>
                          <p
                            class="text-left text-small"
                            style="font-family: OpenSans-Regular; color: gray; font-size: 10px;"
                          >{{remainingCount}}</p>
                        </div>
                      </mdb-col>
                    </mdb-row>
                  </mdb-card-body>
                </mdb-col>
              </mdb-row>
              <mdb-row>
              </mdb-row>
            </mdb-step>
            <mdb-step name="Agregar invitados" slot="content" :number="2">
              <mdb-row>
                <mdb-col lg="7">
                  <mdb-card-body>
                    <p style="font-family: OpenSans-Bold; font-size: 14px">Invitación manual</p>
                    <form id="form1" class="needs-validation" @submit="checkFormInvited">
                      <mdb-row>
                        <mdb-col md="4">
                          <div class="form-group">
                            <label for="invitedFirstName">Nombre *</label>
                            <input
                              class="Rectngulo-1673"
                              type="text"
                              id="invitedFirstName"
                              required
                              v-model="invitedModel.firstName"
                            />
                          </div>
                        </mdb-col>
                        <mdb-col md="4">
                          <div class="form-group">
                            <label for="invitedLastName">Apellidos *</label>
                            <input
                              class="Rectngulo-1673"
                              type="text"
                              id="invitedLastName"
                              required
                              v-model="invitedModel.lastName"
                            />
                          </div>
                        </mdb-col>
                      </mdb-row>
                      <mdb-row>
                        <mdb-col md="4">
                          <div class="form-group">
                            <label for="invitedPhone">Número telefónico</label>
                            <input
                              class="Rectngulo-1673"
                              type="number"
                              id="invitedPhone"
                              v-model="invitedModel.phone"
                            />
                          </div>
                        </mdb-col>
                        <mdb-col md="4">
                          <div class="form-group">
                            <label for="invitedEmail">Correo electrónico</label>
                            <input
                              class="Rectngulo-1673"
                              type="email"
                              pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}"
                              id="invitedEmail"
                              v-model="invitedModel.email"
                            />
                          </div>
                        </mdb-col>
                        <mdb-col md="3">
                          <div class="md-form mb-0">
                            <button
                              type="submit"
                              @click="metodo()"
                              class="btn btn-verde"
                              style="padding: 4px 20px; font-size: 12px; width: 136px; height: 37px; margin-top: 0rem;"
                            >Agregar invitado</button>
                          </div>
                        </mdb-col>
                      </mdb-row>
                    </form>
                  </mdb-card-body>
                </mdb-col>
                <mdb-col lg="5" class="Rectngulo-650">
                  <mdb-card-body class="form">
                    <p
                      style="font-family: OpenSans-Bold; font-size: 14px; margin-bottom: -3%;"
                    >Invitados agregados</p>
                  </mdb-card-body>
                  <mdb-tbl
                    responsive
                    :scrollY="false"
                    maxHeight="400px"
                    style="font-family: OpenSans-Semibold; font-size: 12px;text-align: center;"
                  >
                    <mdb-tbl-head>
                      <tr>
                        <th scope="col" style="font-size: 12px; text-align: center;">#</th>
                        <th scope="col" style="font-size: 12px; text-align: center;">Nombre</th>
                        <th scope="col" style="font-size: 12px; text-align: center;">Opciones</th>
                      </tr>
                    </mdb-tbl-head>
                    <mdb-tbl-body>
                      <tr v-for="(item, index) in guestList" v-bind:key="index">
                        <td
                          style="font-size: 12px !important; font-family: OpenSans-Semibold !important;"
                        >{{index+1}}</td>
                        <td
                          style="font-size: 12px !important; font-family: OpenSans-Semibold !important;"
                        >{{item.firstName+ " "+ item.lastName}}</td>
                        <td>
                          <div>
                            <button
                              type="button"
                              class="btn btn-verde btn-edit"
                              @click="editInvited(index, item)"
                            >
                              <i class="far fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-danger btn-edit"
                              @click="deleteInvited(index, item)"
                            >
                              <i class="far fa-trash-alt"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </mdb-tbl-body>
                  </mdb-tbl>
                </mdb-col>
                <mdb-col lg="6" class="responsive-col">
                  <mdb-card-body>
                    <p style="font-family: OpenSans-Bold; font-size: 14px">Invitación masiva</p>
                    <mdb-row>
                      <mdb-col md="6">
                        <div class="md-form mb-0">
                          <span>1.- Descarga la plantilla de invitados</span>
                        </div>
                      </mdb-col>
                      <mdb-col md="6">
                        <div class="md-form mb-0">
                          <span>2.- Adjunta la plantilla de invitados</span>
                        </div>
                      </mdb-col>
                    </mdb-row>
                    <mdb-row>
                      <mdb-col md="6">
                        <div class="md-form mb-0">
                          <a
                            :href="imgServer+'apps/myfrac/admin/assets/lista_invitados.xlsx'"
                            class="btn btn-azul"
                            role="button"
                            style="font-family: OpenSans-Semibold; font-size: 12px; width: 137px; height: 45px; text-transform: capitalize; object-fit: contain;"
                            download
                          >Descargar</a>
                        </div>
                      </mdb-col>
                      <mdb-col md="6">
                        <div v-show="(!uploadingCSV && !uploadSuccess)">
                          <div class="row center-align" style="margin-bottom: 10px;">
                            <div class="col s12 m12 l12"></div>
                          </div>
                          <div class="row">
                            <div class="form-csv" @dragover.prevent @drop.prevent="handleFileEvent" >
                              <form enctype="multipart/form-data" id="fileUploadForm">
                                <input
                                  id="file_csv"
                                  name="file"
                                  type="file"
                                  accept=".xlsx,.xls,.csv,.ods"
                                  ref="fileupload"
                                  @change="handleFileEvent($event)"
                                />
                                <div
                                  id="csv-success"
                                  class="center-align ml-3 mr-3"
                                  style="font-size: 12px; text-align: center; margin-top: 15%; color: #a09c9c;"
                                >
                                  <i
                                    class="far fa-copy"
                                    style="padding: 15px 10px; font-size: 30px; color: #e8e9ec;"
                                  ></i>
                                  <br />Arrastra la plantilla aquí o
                                  <u style="color:blue;">
                                    <span style="color:blue;">adjúntala desde tu computadora</span>
                                  </u>
                                </div>
                                <h6 id="csv-failed" class="center-align" style="display: none">
                                  <u style="color:red;">
                                    <span style="color:red;">Intenta de nuevo</span>
                                  </u>
                                </h6>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div v-show="(uploadingCSV && !uploadSuccess)">
                          <div class="row" style="margin-bottom: 25%;"></div>
                          <div class="row center-align">
                            <h4 style="color:#5d6078">Importando Lista</h4>
                            <h5 style="color:#5d6078">Espera un momento</h5>
                            <div class="progress">
                              <div class="indeterminate"></div>
                            </div>
                          </div>
                        </div>
                        <div v-show="(!uploadingCSV && uploadSuccess)">
                          <div class="row center-align" v-show="badlist">
                            <div class="col s12 m12 l12">
                              <p style="font-size: 20px; margin:0;">
                                Algunos invitados no se pudieron insertar.
                                <a
                                  style="cursor: pointer;"
                                  onclick="downloadbadExcel()"
                                >Descargar</a>
                              </p>
                              <ul style="margin:0;">Causas</ul>
                            </div>
                          </div>
                          <div class="row center-align csvuploadsuccess">
                            <h4
                              style="color:#5d6078; padding-top: 15%;"
                            >Lista importada exitosamente</h4>
                            <h5 style="color:#5d6078;">Los invitados fueron agregados con éxito</h5>
                          </div>
                        </div>
                      </mdb-col>
                    </mdb-row>
                  </mdb-card-body>
                </mdb-col>
              </mdb-row>
              <mdb-row></mdb-row>
            </mdb-step>
            <mdb-step name="Personalizar invitación" slot="content" :number="3">
              <mdb-row>
                <mdb-col lg="6">
                  <div class="mt-3">
                    <p
                      style="font-family: OpenSans-Bold; font-size: 14px;"
                    >Editar el estilo de la invitación</p>
                    <div class="md-form">
                      <mdb-row class="ml-2">
                        <mdb-col>
                          <span style="font-size: 15px;">Color de texto</span>
                        </mdb-col>
                        <mdb-col>
                          <div class="form-group">
                            <verte v-model="colorText" picker="wheel" model="hex"></verte>
                          </div>
                        </mdb-col>
                      </mdb-row>
                    </div>
                    <div class="md-form">
                      <mdb-row class="ml-2">
                        <mdb-col>
                          <span style="font-size: 15px;">Color de Fondo</span>
                        </mdb-col>
                        <mdb-col>
                          <div class="form-group">
                            <verte v-model="colorFront" picker="wheel" model="hex"></verte>
                          </div>
                        </mdb-col>
                      </mdb-row>
                    </div>
                    <div class="md-form">
                      <mdb-row class="ml-2">
                        <mdb-col>
                          <span style="font-size: 15px;">Cambiar imagen de portada</span>
                        </mdb-col>
                        <mdb-col>
                          <a
                            class="btn btn-verde"
                            style="padding: 9px 10px; font-size: 12px; width: 136px; height: 37px; margin-top: 0rem;"
                            @click="toggleShow2"
                          >Adjuntar imagen</a>
                          <my-upload
                            field="img"
                            @crop-success="cropSuccess2"
                            :width="700"
                            :height="300"
                            v-model="showImg2"
                            img-format="png"
                            langType="es-MX"
                            :noCircle="true"
                          ></my-upload>
                        </mdb-col>
                      </mdb-row>
                    </div>
                    <div class="md-form">
                      <mdb-row class="ml-2">
                        <mdb-col>
                          <span style="font-size: 15px;">Cambiar imagen del anfitrión</span>
                        </mdb-col>
                        <mdb-col>
                          <a
                            class="btn btn-verde"
                            style="padding: 9px 10px; font-size: 12px; width: 136px; height: 37px; margin-top: 0rem;"
                            @click="toggleShow"
                          >Adjuntar imagen</a>
                          <my-upload
                            field="img"
                            @crop-success="cropSuccess"
                            :width="100"
                            :height="100"
                            v-model="showImg"
                            img-format="png"
                            langType="es-MX"
                            :noSquare="true"
                          ></my-upload>
                        </mdb-col>
                      </mdb-row>
                    </div>
                    <div class="text-center">
                      <a @click="cleanCard" class="btn btn-azul" style="text-transform: inherit;">
                        <mdb-icon icon="undo" />Deshacer cambios
                      </a>
                    </div>
                  </div>
                </mdb-col>
                <mdb-col lg="6">
                  <mdb-card class="mt-3 mb-3" testimonial v-bind:style="{borderRadius: '5px'}">
                    <label class="image-upload2" for="file-input">
                      <img
                        alt="icono editar"
                        :src="imgServer+'apps/myfrac/admin/assets/Editar@3x.png'"
                        @click="toggleShow2"
                      />
                    </label>
                    <!----IMAGEN DE PORTADA-->
                    <div @click="toggleShow3">
                      <div class="col-lg-6">
                        <my-upload
                          field="img"
                          @crop-success="cropSuccess3"
                          :width="500"
                          :height="300"
                          v-model="showImg3"
                          img-format="png"
                          langType="es-MX"
                          :noCircle="true"
                        ></my-upload>
                      </div>
                      <mdb-card-image
                        v-if="urlFile"
                        :src="urlFile"
                        class="header-card-img"
                        v-bind:style="{borderRadius: '5px', display: 'block', marginLeft: 'auto',marginRight: 'auto', width: 'auto', height: '198px', marginTop: '-18px'}"
                      ></mdb-card-image>
                    </div>
                    <img
                      alt="qrcode"
                      :src="imgServer+'apps/myfrac/admin/assets/frame.png'"
                      class="img-fluid qrcode-class"
                    />
                    <mdb-card-body
                      v-bind:style="{backgroundColor: colorFront}"
                      class="card-body-width"
                    >
                      <mdb-row style="text-align: center; display: inline;">
                        <div
                          v-bind:style="{color: colorText}"
                          style="margin-bottom: -20%; margin-top: 5%;"
                        >
                          <span style="font-family: OpenSans-Semibold; font-size: 21px;">
                            <strong>{{form[0].title}}</strong>
                          </span>
                        </div>
                      </mdb-row>
                      <br />
                      <mdb-row v-bind:style="{marginTop: '20%'}">
                        <mdb-col md="3">
                          <label class="image-upload" for="file-input2">
                            <img
                              alt="icono editar"
                              :src="imgServer+'apps/myfrac/admin/assets/Editar@3x.png'"
                              @click="toggleShow"
                            />
                          </label>
                          <!----IMAGEN DE AVATAR-->
                          <div @click="toggleShow4">
                            <div class="col-lg-6">
                              <my-upload
                                field="img"
                                @crop-success="cropSuccess4"
                                :width="100"
                                :height="100"
                                v-model="showImg4"
                                img-format="png"
                                langType="es-MX"
                                :noSquare="true"
                              ></my-upload>
                            </div>
                            <mdb-avatar class="avatar-width" style="width: auto; position: static;">
                              <img alt="avatar invitacion" :src="urlAvatar" class="rounded-circle" />
                            </mdb-avatar>
                          </div>
                        </mdb-col>
                        <mdb-col md="9" v-bind:style="{textAlign: '-webkit-left'}">
                          <div v-bind:style="{color: colorText}">
                            <p style="font-size: 14px; margin-top: 5%;">
                              Organizado por
                              <span class="blue-text">{{residentModel.text}}</span>
                            </p>
                          </div>
                        </mdb-col>
                      </mdb-row>
                      <br />
                      <mdb-row>
                        <mdb-col md="2">
                          <div>
                            <span>
                              <img
                              alt="icono usuario"
                                :src="imgServer+'apps/myfrac/admin/assets/User_icon.png'"
                                class="img-fluid"
                              />
                            </span>
                          </div>
                        </mdb-col>
                        <mdb-col md="6">
                          <div
                            v-bind:style="{color: colorText, textAlign: '-webkit-left'}"
                            style="font-size: 14px"
                          >{{invitado}}</div>
                        </mdb-col>
                      </mdb-row>
                      <br />
                      <mdb-row>
                        <mdb-col md="2">
                          <div>
                            <span>
                              <img
                                alt="icono calendario"
                                :src="imgServer+'apps/myfrac/admin/assets/calendar-alt.png'"
                                class="img-fluid"
                              />
                            </span>
                          </div>
                        </mdb-col>
                        <mdb-col md="6" v-bind:style="{textAlign: '-webkit-left'}">
                          <div
                            v-bind:style="{color: colorText, fontSize: '14px'}"
                          >{{optionsDate.week[indexDay2]+' '+indexDay+' de '+ optionsDate.month[indexMonth]+' del '+indexYear}}</div>
                        </mdb-col>
                      </mdb-row>
                      <br />
                      <mdb-row>
                        <mdb-col md="2">
                          <div>
                            <span>
                              <img
                              alt="icono reloj"
                                :src="imgServer+'apps/myfrac/admin/assets/clock.png'"
                                class="img-fluid"
                              />
                            </span>
                          </div>
                        </mdb-col>
                        <mdb-col md="6" v-bind:style="{textAlign: '-webkit-left'}">
                          <div
                            v-bind:style="{color: colorText, fontSize: '14px'}"
                          >{{'De '+TimeStart +'hrs, a '+TimeEnd+'hrs'}}</div>
                        </mdb-col>
                      </mdb-row>
                      <br />
                      <mdb-row>
                        <mdb-col md="2">
                          <div>
                            <span>
                              <img
                                alt="icono marker"
                                :src="imgServer+'apps/myfrac/admin/assets/map-marker-alt.png'"
                                class="img-fluid"
                              />
                            </span>
                          </div>
                        </mdb-col>
                        <mdb-col md="6">
                          <div
                            v-bind:style="{color: colorText, textAlign: '-webkit-left'}"
                            style="font-size: 14px"
                          >{{placeModel.text+', '+ fracc}}</div>
                        </mdb-col>
                      </mdb-row>
                      <br />
                      <mdb-row>
                        <div class="ml-3">
                          <p
                            v-bind:style="{color: colorText, textAlign: '-webkit-left', wordBreak: 'break-all'}"
                            style="font-family:OpenSans-Regular; margin-left: 15px; margin-right: 30px;"
                          >{{ description }}</p>
                        </div>
                      </mdb-row>
                    </mdb-card-body>
                  </mdb-card>
                </mdb-col>
              </mdb-row>
            </mdb-step>
          </mdb-stepper>
        </mdb-card-body>
        <!--/.Card content-->
      </mdb-card>
      <!--/.Card-->
    </section>

    <Popup ref="modalInvitado" size="md-mod3" title="Editar invitado" classTitle="popup__title-mod" header="popup__header">
      <div>
        <form id="form2" class="needs-validation" @submit="saveEdit">
          <mdb-row class="my-custom-row">
            <mdb-col md="5">
              <div class="form-group">
                <label for="invitedFirstName">Nombre</label>
                <input
                  class="Rectangle-536"
                  type="text"
                  id="invitedFirstName"
                  required
                  v-model="invitedEdit.firstName"
                />
              </div>
            </mdb-col>
            <mdb-col md="5">
              <div class="form-group">
                <label for="invitedLastName">Apellidos</label>
                <input
                  class="Rectangle-536"
                  type="text"
                  id="invitedLastName"
                  required
                  v-model="invitedEdit.lastName"
                />
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row class="my-custom-row">
            <mdb-col md="5">
              <div class="form-group">
                <label for="invitedPhone">Teléfono</label>
                <input
                  class="Rectangle-536"
                  type="number"
                  id="invitedPhone"
                  v-model="invitedEdit.phone"
                />
              </div>
            </mdb-col>
            <mdb-col md="5">
              <div class="form-group">
                <label for="invitedEmail">Correo electrónico</label>
                <input
                  class="Rectangle-536"
                  type="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}"
                  id="invitedEmail"
                  v-model="invitedEdit.email"
                />
              </div>
            </mdb-col>
          </mdb-row>
          <div class="text-center mb-3">
            <div v-if="!modalImport">
              <mdb-btn color="color-prev" class="btn-prev" @click="closeModal()">Cancelar</mdb-btn>
              <button type="submit" class="btn btn-next btn-color-next">Guardar</button>
              <mdb-btn
                type="button"
                class="btn-verde"
                @click="modalImport = true"
                size="md"
              >Importar desde plantilla</mdb-btn>
            </div>
            <div v-else>
              <!--IMPORTAR DESDE PLANTILLA -->
              <h5>
                Importar desde archivo los datos del invitado
              </h5>
              <mdb-row>
                <mdb-col md="6">
                  <div class="md-form mb-0">
                    <span>1.- Descarga la plantilla de invitados</span>
                  </div>
                </mdb-col>
                <mdb-col md="6">
                  <div class="md-form mb-0">
                    <span>2.- Adjunta la plantilla de invitados</span>
                  </div>
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col md="6">
                  <div class="md-form mb-0">
                    <a
                      :href="imgServer+'apps/myfrac/admin/assets/lista_invitados.xlsx'"
                      class="btn btn-verde"
                      role="button"
                      style="font-family: OpenSans-Semibold; font-size: 12px; width: 137px; height: 45px; text-transform: capitalize; object-fit: contain;"
                      download
                    >Descargar</a>
                  </div>
                </mdb-col>
                <mdb-col md="6">
                  <div v-show="(!uploadingCSV && !uploadSuccess)">
                    <div class="row center-align" style="margin-bottom: 10px;">
                      <div class="col s12 m12 l12"></div>
                    </div>
                    <div class="row">
                      <div class="form-csv" @dragover.prevent @drop.prevent="handleFileEvent($event, invitedEdit)">
                        <form enctype="multipart/form-data" id="fileUploadForm">
                          <input
                            id="file_csv"
                            name="file"
                            type="file"
                            accept=".xlsx,.xls,.csv,.ods"
                            ref="fileupload"
                            @change="handleFileEvent($event, invitedEdit)"
                          />
                          <div
                            id="csv-success"
                            class="center-align ml-3 mr-3"
                            style="font-size: 12px; text-align: center; margin-top: 15%; color: #a09c9c;"
                          >
                            <i
                              class="far fa-copy"
                              style="padding: 15px 10px; font-size: 30px; color: #e8e9ec;"
                            ></i>
                            <br />Arrastra la plantilla aquí o
                            <u style="color:blue;">
                              <span style="color:blue;">adjúntala desde tu computadora</span>
                            </u>
                          </div>
                          <h6 id="csv-failed" class="center-align" style="display: none">
                            <u style="color:red;">
                              <span style="color:red;">Intenta de nuevo</span>
                            </u>
                          </h6>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div v-show="(uploadingCSV && !uploadSuccess)">
                    <div class="row" style="margin-bottom: 25%;"></div>
                    <div class="row center-align">
                      <h4 style="color:#5d6078">Importando Lista</h4>
                      <h5 style="color:#5d6078">Espera un momento</h5>
                      <div class="progress">
                        <div class="indeterminate"></div>
                      </div>
                    </div>
                  </div>
                  <div v-show="(!uploadingCSV && uploadSuccess)">
                    <div class="row center-align" v-show="badlist">
                      <div class="col s12 m12 l12">
                        <p style="font-size: 20px; margin:0;">
                          Algunos invitados no se pudieron insertar.
                          <a
                            style="cursor: pointer;"
                            onclick="downloadbadExcel()"
                          >Descargar</a>
                        </p>
                        <ul style="margin:0;">Causas</ul>
                      </div>
                    </div>
                    <div class="row center-align csvuploadsuccess">
                      <h4 style="color:#5d6078; padding-top: 15%;">Lista importada exitosamente</h4>
                      <h5 style="color:#5d6078;">Los invitados fueron agregados con éxito</h5>
                    </div>
                  </div>
                </mdb-col>
              </mdb-row>
              <mdb-btn color="color-prev" class="btn-prev" @click="closeModal()">Cancelar</mdb-btn>
              <button type="submit" class="btn btn-next btn-color-next">Guardar</button>
            </div>
          </div>
        </form>
      </div>
    </Popup>
    <!-- Icono de carga rotando -->
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner"></div> <!-- Spinner con CSS -->
    </div>
  </mdb-container>
</template>
<script lang="javascript" src="../../dist/xlsx.full.min.js"></script>
<script>
/* eslint-disable */
import XLSX from "xlsx";
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import Verte from "verte";
import "verte/dist/verte.css";
import { ModelSelect } from "vue-search-select";
import "babel-polyfill";
import myUpload from "vue-image-crop-upload";
import Popup from "./../../core/popup"

import {
  mdbContainer,
  mdbStepper,
  mdbTooltip,
  mdbStep,
  mdbView,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbInput,
  mdbRow,
  mdbCol,
  mdbTextarea,
  mdbIcon,
  mdbBtn,
  mdbDatePicker,
  mdbTimePicker,
  mdbTbl,
  mdbTblHead,
  mdbTblBody,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbFileInput,
  mdbAvatar,
  mdbSelect,
  mdbFormInline
} from "mdbvue";
import { getScript } from "jquery"
import { forEach } from "jszip"
const fs = require("fs");

export default {
  name: "Stepper",
  components: {
    mdbTooltip,
    mdbContainer,
    mdbStepper,
    mdbStep,
    mdbView,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbInput,
    mdbTextarea,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbBtn,
    mdbDatePicker,
    mdbTimePicker,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbAvatar,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbFileInput,
    mdbSelect,
    mdbFormInline,
    Verte,
    ModelSelect,
    "my-upload": myUpload,
    Popup,
  },
  data() {
    return {
      imgDataUrl: "",
      modalImport: false,
      dataGuestEdited: null,
      isLoading: false,
      showImg: false,
      showImg2: false,
      showImg3: false,
      showImg4: false,
      elegant: false,
      indexEdit: null,
      colorText: "#8e8e8e",
      colorFront: "#ffffff",
      urlFile:
        Servers.serverImg + "apps/myfrac/admin/assets/Placeholder@2x.png",
      uuidFile: "",
      urlAvatar:
        Servers.serverImg + "apps/myfrac/admin/assets/imgPerfil@3x.png",
      uuidAvatar: "",
      profileFile: null,
      backgroundFile: null,
      extension: "",
      extension2: "",
      validationDate: false,
      dateValid: false,
      userValid: false,
      placeValid: false,
      guestList: [],
      errorsOnFileList: [],
      nuevosInvitados: [],
      invitadosUuid: [],
      isAdmin: false,
      XVParty: true,
      commonAreaDisable: false,
      nightParty: false,
      fracc: "Fraccionamiento",
      invitado: "Invitado de ejemplo",
      residentsFile: "",
      resident: "",
      uploadingCSV: false,
      uploadSuccess: false,
      badlist: false,
      maxCount: 200,
      remainingCount: 200,
      access_token: "",
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      description: "",
      commonAreas: [],
      residentsList: [],
      eventoRespaldo: "",
      massiveEvents: "",
      headerTitle: "Crear evento masivo",
      residentModel: {
        value: "",
        text: ""
      },
      placeModel: {
        value: "",
        text: ""
      },
      invitedModel: {
        uuid: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
      },
      invitedEdit: {
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
      },
      limitDate: [
        {
          type: "fromto",
          from: "",
          to: "2100-12-30"
        }
      ],
      optionsDate: {
        week: ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"],
        month: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        buttons: {
          ok: "Aceptar",
          clear: "Limpiar",
          cancel: "Cancelar",
          today: "Hoy"
        },
        format: "YYYY-MM-DD"
      },
      months: [
        "ENE",
        "FEB",
        "MAR",
        "ABR",
        "MAY",
        "JUN",
        "JUL",
        "AGO",
        "SEP",
        "OCT",
        "NOV",
        "DIC"
      ],
      indexDay: null,
      indexMonth: null,
      indexYear: null,
      indexDay2: null,
      TimeStart: null,
      TimeEnd: null,
      validatedSteps: {},
      form: [
        {
          title: "",
          timepicker: "",
          datepicker: ""
        },
        {},
        {}
      ],
      rows: [],
      activeSession: false
    }; // END RETURN
  },
  methods: {
    removeEvent() {
      let aux = this;
      if (this.activeSession) {
        Swal.fire({
          title:
            "<span style='font-size: 16px; font-weight: 400; color: #ffffff; margin-top: 12px; margin-right: 120px; font-family: OpenSans-Regular;'><img src = " +
            this.imgServer +
            "apps/myfrac/admin/assets/Alerta_Icon_white.png class='img-fluid' style='width: 19.2px; height: 15.3px; margin-top: -5px;'></img>&nbsp ¿Seguro que deseas salir?</span>",
          html:
            "<span style='font-size: 12px;'>Si sales sin guardar se perderán los cambios realizados</span>",
          showCancelButton: true,
          width: "30%",
          confirmButtonText: "Salir",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
          customClass: {
            header: "Rect-BG",
            confirmButton: "btn-modal-accept",
            cancelButton: "btn-modal-cancel"
          }
        }).then(result => {
          if (result.value) {
            if (this.$route.query.token === undefined) {
              //ES EVENTO NUEVO Y PUEDES ELIMINAR
              Axios.delete(
                aux.urlServer + "api/massiveEvents/" + aux.massiveEvents,
                {
                  responseType: "application/json",
                  headers: {
                    Authorization:
                      "Bearer " + localStorage.getItem("access_token")
                  }
                }
              ).then(
                function(response) {
                  aux.headerTitle = "Crear evento masivo";
                  aux.activeSession = false;
                  window.location.reload();
                  window.location.href = "/massiveEvents";
                },
                function(error) {
                  aux.showMessageError(
                    "Ha ocurrido un error al crear el EVENTO",
                    error.response.data
                  );
                  return false;
                }
              );
            } else {
              this.redoEvent();
              this.activeSession = false;
              window.location.href = "/massiveEvents";
              //ES ACTUALIZACION Y DEBES REGRESAR A COMO ESTABA TODO ANTES
            }
          }
        });
      } else {
        this.activeSession = false;
        window.location = "/massiveEvents";
      }
    },
    saveAndExit() {
      if (this.activeSession) {
        if (this.guestList.length > 0) this.saveGuest();

        Swal.fire({
          title:
            "<span style='font-size: 16px; font-weight: 400; color: #ffffff; margin-top: 10px; margin-right: 200px; font-family: OpenSans-Regular;'><img src =" +
            this.imgServer +
            "apps/myfrac/admin/assets/Alerta_Icon_white.png class='img-fluid' style='width: 19.2px; height: 15.3px; margin-top: -5px;'></img>&nbspEvento guardado</span>",
          html:
            "<span style='font-size: 12px;'>Podrás continuar editando el evento cuando desees</span>",
          showCancelButton: true,
          width: "30%",
          confirmButtonText: "Guardar y salir",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
          customClass: {
            header: "Rect-BG",
            confirmButton: "btn-modal-accept",
            cancelButton: "btn-modal-cancel"
          }
        }).then(result => {
          if (result.value) {
            this.activeSession = false;
            window.location = "/massiveEvents";
          }
        });
      } else {
        this.activeSession = false;
        window.location = "/massiveEvents";
      }
    },
    toggleShow() {
      this.showImg = !this.showImg;
    },
    toggleShow2() {
      this.showImg2 = !this.showImg2;
    },
    toggleShow3() {
      this.showImg2 = !this.showImg2;
    },
    toggleShow4() {
      this.showImg4 = !this.showImg4;
    },
    cropSuccess(imgDataUrl, field) {
      ///AVATAR IMAGE
      this.urlAvatar = imgDataUrl;
      this.profileFile = imgDataUrl.split(",")[1];
      this.extension2 = imgDataUrl.split(";")[0];
    },
    cropSuccess2(imgDataUrl, field) {
      ////BACKGROUND IMAGE
      this.urlFile = imgDataUrl;
      this.backgroundFile = imgDataUrl.split(",")[1];
      this.extension = imgDataUrl.split(";")[0];
    },
     cropSuccess4(imgDataUrl, field) {
      ///AVATAR IMAGE
      this.urlAvatar = imgDataUrl;
      this.profileFile = imgDataUrl.split(",")[1];
      this.extension2 = imgDataUrl.split(";")[0];
    },
    cropSuccess3(imgDataUrl, field) {
      ////BACKGROUND IMAGE
      this.urlFile = imgDataUrl;
      this.backgroundFile = imgDataUrl.split(",")[1];
      this.extension = imgDataUrl.split(";")[0];
    },
    metodo() {
      document.getElementById("form1").classList.add("was-validated");
      document.getElementById("invitedFirstName").classList.add("form-control");
      document.getElementById("invitedLastName").classList.add("form-control");
    },
    downloadNewInvitations() {
      var type = "application/zip";
      var downloadName = "invitaciones.zip";
      var ContentType = "multipart/form-data";
      var uuidArray = "";
      if (this.nuevosInvitados.length === 1) {
        type = "image/png";
        downloadName = this.guestList[this.guestList.length-1].firstName + " " + this.guestList[this.guestList.length-1].lastName;+".png";
        ContentType = "image/png";
      }
      this.nuevosInvitados.map(function(value, key) {
        uuidArray = uuidArray + "uuid=" + value.uuid + "&";
      });

      uuidArray = uuidArray.slice(0, -1);

      let aux = this;
      Axios.get(
        this.urlServer + "api/massiveEventGuests/invitation?" + uuidArray,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": ContentType
          }
        }
      ).then(
        function(response) {
          let blob = new Blob([response.data], { type: type });
          const downloadUrl = URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = downloadUrl;
          a.download = downloadName;
          document.body.appendChild(a);
          a.click();
          Swal.hideLoading("Invitaciones descargadas");
          aux.closeModal();
          aux.massiveEvents = "";
          aux.headerTitle = "Crear evento masivo";
          window.location.href = "/massiveEvents";
        },
        function(error) {
          aux.showMessageError("Ha ocurrido un error", error);
          return false;
        }
      );
    },
    downloadInvitations() {
      var type = "application/zip";
      var downloadName = "invitaciones.zip";
      var ContentType = "multipart/form-data";
      if (this.guestList.length === 1) {

        type = "image/png";
        downloadName = this.guestList[0].firstName + " " + this.guestList[0].lastName;+".png";
        ContentType = "image/png";
      }
      let aux = this;
      Axios.get(
        this.urlServer +
          "api/massiveEvents/" +
          this.massiveEvents +
          "/invitation",
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": ContentType
          }
        }
      ).then(
        function(response) {
          let blob = new Blob([response.data], { type: type });
          const downloadUrl = URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = downloadUrl;
          a.download = downloadName;
          document.body.appendChild(a);
          a.click();
          Swal.hideLoading();
          Swal.fire({
            title: "<span style='font-size: 20px;'>Descarga completada</span>",
            width: "20%",
            allowOutsideClick: false,
            showConfirmButton: true
          });
          aux.closeModal();
          aux.massiveEvents = "";
          aux.headerTitle = "Crear evento masivo";
          window.location.href = "/massiveEvents";
        },
        function(error) {
          aux.showMessageError("Ha ocurrido un error", error);
          window.location.href = "/massiveEvents";
          return false;
        }
      );
    },
    savePost(downloadInvitations) {
      let aux = this;
      var extensionFinal;
      var mimeTypeFinal;
      var uuid = aux.uuidv4();
      var colorF = null;
      var textC = null;
      var dataProfile = null;
      var databackgroundImage = null;

      if (aux.backgroundFile != null) {
        aux.uuidFile = "";
        if (aux.extension == "data:image/png") {
          extensionFinal = "png";
          mimeTypeFinal = "image/png";
        } else {
          extensionFinal = "jpg";
          mimeTypeFinal = "image/jpg";
        }
        databackgroundImage = {
          name: uuid,
          extension: extensionFinal,
          mimeType: mimeTypeFinal,
          content: aux.backgroundFile
        };
      }

      if (aux.profileFile != null) {
        aux.uuidAvatar = "";
        if (aux.extension2 == "data:image/png") {
          extensionFinal = "png";
          mimeTypeFinal = "image/png";
        } else {
          extensionFinal = "jpg";
          mimeTypeFinal = "image/jpg";
        }
        dataProfile = {
          name: uuid,
          extension: extensionFinal,
          mimeType: mimeTypeFinal,
          content: aux.profileFile
        };
      }

      if (aux.uuidFile !== "") {
        databackgroundImage = {
          uuid: aux.uuidFile,
          name: null,
          extension: null,
          mimeType: null,
          content: null
        };
      }
      if (aux.uuidAvatar !== "") {
        dataProfile = {
          uuid: aux.uuidAvatar,
          name: null,
          extension: null,
          mimeType: null,
          content: null
        };
      }

      if (aux.colorText != "#8e8e8e") {
        textC = aux.colorText.split("#")[1];
      }
      if (aux.colorFront != "#ffffff") {
        colorF = aux.colorFront.split("#")[1];
      }
      var data = {
        backgroundColor: colorF,
        foregroundColor: textC,
        profile: dataProfile,
        backgroundImage: databackgroundImage
      };

      Axios.put(
        this.urlServer +
          "api/massiveEvents/" +
          this.massiveEvents +
          "/configure",
        data,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function(response) {
          aux.activeSession = false;

          Swal.update({
            title: "<span style='font-size: 20px;'>Carga finalizada</span>",
            width: "20%",
            allowOutsideClick: false,
            onBeforeOpen: () => {
              Swal.hideLoading();
            }
          });

          if (downloadInvitations) {
            if (aux.$route.query.token === undefined) {
              Swal.fire({
                title:
                  "<span style='font-size: 20px;'>Descargando invitaciones...</span>",
                width: "30%",
                allowOutsideClick: false,
                onBeforeOpen: () => {
                  Swal.showLoading();
                  aux.downloadInvitations();
                }
              });
            } else {
              if (aux.nuevosInvitados.length > 0) {
                Swal.fire({
                  title:
                    "<span style='font-size: 20px;'>¿Deseas descargar todas las invitaciones nuevamente?</span>",
                  width: "50%",
                  showCancelButton: true,
                  confirmButtonText:
                    '<i class="far fa-file-archive"></i> Si, descargar todas',
                  cancelButtonText:
                    '<i class="far fa-images"></i> No, descargar solo las nuevas',
                  reverseButtons: true,
                  showLoaderOnConfirm: true,
                  customClass: {
                    confirmButton: "btn-modal-accept",
                    cancelButton: "btn-modal-cancel"
                  },
                  allowOutsideClick: false,
                  onAfterClose: () => {
                    Swal.fire({
                      title:
                        "<span style='font-size: 20px;'>Descargando invitaciones...</span>",
                      width: "30%",
                      allowOutsideClick: false,
                      onBeforeOpen: () => {
                        Swal.showLoading();
                      }
                    });
                  }
                }).then(result => {
                  if (result.value) {
                    aux.downloadInvitations();
                  } else {
                    aux.downloadNewInvitations();
                  }
                });
              } else {
                Swal.fire({
                  title:
                    "<span style='font-size: 20px;'>Descargando invitaciones...</span>",
                  width: "30%",
                  allowOutsideClick: false,
                  onBeforeOpen: () => {
                    Swal.showLoading();
                    aux.downloadInvitations();
                  }
                });
              }
            }
          } else {
            Swal.hideLoading();
            aux.closeModal();
            aux.massiveEvents = "";
            aux.headerTitle = "Crear evento masivo";
            window.location.href = "/massiveEvents";
          }
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error);
        });
    },
    updateEvent() {
      let aux = this;
      var dateEvent = new Date(
        this.form[0].datepicker + " " + this.form[0].timepicker
      );
       var localTime =  this.form[0].datepicker + "T"+ (this.form[0].timepicker.slice(0,5))+":00"
      if (this.placeModel.value === null) {
        var data = {
          title: this.form[0].title,
          additionalInformation: this.description,
          startDate: localTime,
          commonArea: null,
          resident: {
            uuid: this.residentModel.value
          }
        };
      } else {
        var data = {
          title: this.form[0].title,
          additionalInformation: this.description,
          startDate: localTime,
          commonArea: {
            uuid: this.placeModel.value
          },
          resident: {
            uuid: this.residentModel.value
          }
        };
      }
      this.indexMonth =
        parseInt((this.form[0].datepicker + "").substring(5, 7)) - 1;
      this.indexDay = parseInt((this.form[0].datepicker + "").substring(8, 10));
      this.indexYear = dateEvent.getFullYear();
      this.indexDay2 = dateEvent.getDay();
      this.indexDay2 = this.indexDay2 - 1;
      this.indexDay2 < 0 ? (this.indexDay2 = 6) : this.indexDay2;
      this.TimeStart = new Date(dateEvent.getTime()).toLocaleTimeString();
      this.TimeEnd = new Date(
        dateEvent.setHours(dateEvent.getHours() + 12)
      ).toLocaleTimeString();

      if (this.TimeStart.length == 8) {
        this.TimeStart = this.TimeStart.slice(0, 5);
      } else {
        this.TimeStart = this.TimeStart.slice(0, 4);
      }

      if (this.TimeEnd.length == 8) {
        this.TimeEnd = this.TimeEnd.slice(0, 5);
      } else {
        this.TimeEnd = this.TimeEnd.slice(0, 4);
      }

      Axios.put(
        this.urlServer + "api/massiveEvents/" + this.massiveEvents,
        data,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function(response) {
          return true;
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error);
          return false;
        });
    },
    saveStep1() {
      let aux = this;
      var dateEvent = new Date(
        this.form[0].datepicker + " " + this.form[0].timepicker
      );
      var offset = new Date().getTimezoneOffset() * 60000;
      var localTime =  this.form[0].datepicker + "T" + (this.form[0].timepicker.slice(0,5))+":00"

      if (this.placeModel.value === null) {
        var data = {
          title: this.form[0].title,
          additionalInformation: this.description,
          startDate: localTime,
          commonArea: null,
          resident: {
            uuid: this.residentModel.value
          }
        };
      } else {
        var data = {
          title: this.form[0].title,
          additionalInformation: this.description,
          startDate: localTime,
          commonArea: {
            uuid: this.placeModel.value
          },
          resident: {
            uuid: this.residentModel.value
          }
        };
      }

      this.indexMonth =
        parseInt((this.form[0].datepicker + "").substring(5, 7)) - 1;
      this.indexDay = parseInt((this.form[0].datepicker + "").substring(8, 10));
      this.indexYear = dateEvent.getFullYear();
      this.indexDay2 = dateEvent.getDay();
      this.indexDay2 = this.indexDay2 - 1;
      this.indexDay2 < 0 ? (this.indexDay2 = 6) : this.indexDay2;
      this.TimeStart = new Date(dateEvent.getTime()).toLocaleTimeString();
      this.TimeEnd = new Date(
        dateEvent.setHours(dateEvent.getHours() + 12)
      ).toLocaleTimeString();

      if (this.TimeStart.length == 8) {
        this.TimeStart = this.TimeStart.slice(0, 5);
      } else {
        this.TimeStart = this.TimeStart.slice(0, 4);
      }

      if (this.TimeEnd.length == 8) {
        this.TimeEnd = this.TimeEnd.slice(0, 5);
      } else {
        this.TimeEnd = this.TimeEnd.slice(0, 4);
      }

      Axios.post(this.urlServer + "api/massiveEvents", data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.massiveEvents = response.data.uuid;
          return true;
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error);
          return false;
        });
    },
    saveGuest() {
      var data = {
        massiveEvent: {
          uuid: this.massiveEvents
        },
        guests: this.guestList
      };
      this.invitadosUuid = this.guestList.filter(function(invited) {
        return invited.uuid != "";
      });

      this.nuevosInvitados = this.guestList.filter(function(invited) {
        return invited.uuid == "";
      });

      if (this.nuevosInvitados.length > 0)
        this.addMultipleGuest(this.nuevosInvitados);
      if (this.invitadosUuid.length > 0)
        this.updateGuest(this.invitadosUuid, this.massiveEvents);

      return;
    },
    saveStep2() {
      let aux = this;
      this.saveGuest();

      Swal.fire({
        title:
          "<span style='font-size: 20px;'>¿Deseas descargar tus invitaciones?</span>",
        imageUrl: "../../../static/Letter@3x.png",
        imageWidth: "22%",
        imageHeight: "auto",
        animation: false,
        width: "30%",
        showCancelButton: true,
        confirmButtonText: '<i class="fas fa-download"></i> Descargar',
        cancelButtonText: "En otro momento",
        reverseButtons: true,
        showLoaderOnConfirm: true,
        customClass: {
          confirmButton: "btn-modal-accept",
          cancelButton: "btn-modal-download"
        },
        preConfirm: () => {},
        allowOutsideClick: false
      }).then(result => {
        Swal.fire({
          title: "<span style='font-size: 20px;'>Cargando evento...</span>",
          width: "20%",
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });
        aux.savePost(result.value);
      });
    },
    saveEdit(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
      //this.elegant = false;
       this.$refs.modalInvitado.toggleModal();
      this.$set(
        this.guestList[this.indexEdit],
        "firstName",
        this.invitedEdit.firstName
      );
      this.$set(
        this.guestList[this.indexEdit],
        "lastName",
        this.invitedEdit.lastName
      );
      this.$set(
        this.guestList[this.indexEdit],
        "phone",
        this.invitedEdit.phone
      );
      this.$set(
        this.guestList[this.indexEdit],
        "email",
        this.invitedEdit.email
      );
      this.invitedEdit = {
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
      };
      this.indexEdit = null;
    },
    closeModal() {
      this.show = false;
      this.$refs.modalInvitado.toggleModal();
      //this.elegant = false;
      this.massiveEvents = null;
      this.invitedEdit = {
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
      };
      this.indexEdit = null;
      this.cleanCard(); /// METODO PARA LIMPIAR
    },
    deleteInvited(index, Invited) {
      Swal.fire({
        title:
          "<span style='font-size: 20px;'>¿Seguro que deseas eliminar a " +
          Invited.firstName +
          " " +
          Invited.lastName +
          "?</span>",
        html:
          "<span style='font-size: 12px;'>No podrás revertir esta acción</span>",
        type: "question",
        showCancelButton: true,
        width: "30%",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        customClass: {
          confirmButton: "btn-modal-accept",
          cancelButton: "btn-modal-cancel"
        }
      }).then(result => {
        if (result.value) {
          var uuidDelete = this.guestList[index].uuid;
          if (uuidDelete != "") {
            this.deleteGuest(uuidDelete);
          }
          this.$delete(this.guestList, index);
        }
      });
    },
    editInvited(index, Invited) {
      // this.elegant = true;
      this.indexEdit = index;
      this.invitedEdit.firstName = Invited.firstName;
      this.invitedEdit.lastName = Invited.lastName;
      this.invitedEdit.phone = Invited.phone;
      this.invitedEdit.email = Invited.email;
      this.$refs.modalInvitado.toggleModal();
    },
    onFocus() {
      var button = document.getElementsByClassName("clockpicker-button");
    },
    getTimeInputValue(val) {
      if (val) {
        this.form[0].timepicker = val;
      } else {
        this.form[0].timepicker = "";
      }
    },
    getDateInputValue(val) {
      if (val) {
        this.dateValid = true;
      } else {
        this.form[0].datepicker = "";
        this.dateValid = false;
      }
    },
    cleanCard() {
      this.colorText = "#8e8e8e";
      this.colorFront = "#ffffff";
      this.urlFile =
        Servers.serverImg + "apps/myfrac/admin/assets/Placeholder@2x.png";
      this.urlAvatar =
        Servers.serverImg + "apps/myfrac/admin/assets/imgPerfil@3x.png";
      this.profileFile = null;
      this.backgroundFile = null;
    },
    validate(e, i) {
      /// "e" is active step and "i" is next step
      debugger;
      let aux = this;
      if (e === 1) {
        this.validationDate = true;
        if (
          this.checkForm(this.form[e - 1]) &&
          !this.userValid &&
          !this.placeValid
        ) {
          this.validatedSteps[e] = true;

          if (this.$route.query.token === undefined && !this.activeSession) {
            this.activeSession = true;
            this.saveStep1();
          } else {
            this.updateEvent();
            if (
              this.eventoRespaldo.title === this.form[0].title &&
              this.eventoRespaldo.startDate.split("T")[0] ===
                this.form[0].datepicker &&
              this.eventoRespaldo.startDate.split("T")[1] ===
                this.form[0].timepicker &&
              this.eventoRespaldo.resident.uuid === this.residentModel.value
            ) {
              this.activeSession = false;
            } else {
              this.activeSession = true;
            }
          }
          this.headerTitle = "Agrega invitados para evento masivo";
        } else {
          this.validatedSteps[e] = false;
        }
      }
      if (e === 2) {
        this.validationDate = false;
        if (this.guestList.length === 0 ) {
          this.validatedSteps[e] = false;
          aux.showMessageError(
            "No puedes continuar",
            "Debes agregar por lo menos a un invitado"
          );
        } else if (this.guestList.length > 0) {
          this.validatedSteps[e] = true;
          //this.saveStep2();
          this.invitado =
            this.guestList[0].firstName + " " + this.guestList[0].lastName;
          this.headerTitle = "Personaliza tu invitación";
          if (this.placeModel.value === null) {
            this.placeModel.text =
              this.resident.testStreet.name + " #" + this.resident.number;
          }
        } else {
          this.validatedSteps[e] = false;
        }
      }
      if (e === 3) {
        document.getElementById("form1").classList.remove("was-validated");
        document
          .getElementById("invitedFirstName")
          .classList.remove("form-control");
        document
          .getElementById("invitedLastName")
          .classList.remove("form-control");

        this.validatedSteps[e] = true;
      }
    },
    checkForm(form) {
      if (this.residentModel.value) this.userValid = false;
      else this.userValid = true;

      if (this.placeModel.value || this.placeModel.text !== "")
        this.placeValid = false;
      else this.placeValid = true;

      return (
        Object.keys(form).length ===
        Object.keys(form).filter(key => form[key].length > 0).length
      );
    },
    checkFormInvited(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
      debugger;
      let found = this.guestList.find(
        element =>
          element.firstName === this.invitedModel.firstName &&
          element.lastName === this.invitedModel.lastName
      );
      if (found == undefined) {
        this.activeSession = true;
        this.guestList.push(this.invitedModel);
        this.pushData();
        Swal.fire({
          title: "<span style='font-size: 20px;'> Agregado</span>",
          html:
            "<span style='font-size: 12px;'>Invitado agregado correctamente</span>",
          type: "success",
          width: "30%",
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn-modal-accept"
          },
          onClose: () => {
            document.getElementById("form1").classList.remove("was-validated");
          }
        });
      } else {
        Swal.fire({
          title:
            "<span style='font-size: 20px;'>¿Estás seguro de agregar a este invitado nuevamente?</span>",
          html:
            "<span style='font-size: 12px;' Encontramos un invitado con este nombre y apellido</span>",
          type: "warning",
          showCancelButton: true,
          reverseButtons: true,
          width: "30%",
          confirmButtonText: "Si, agregar",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn-modal-accept",
            cancelButton: "btn-modal-cancel"
          }
        }).then(result => {
          if (result.value) {
            this.activeSession = true;
            this.guestList.push(this.invitedModel);
            this.pushData();
            Swal.fire({
              title: "<span style='font-size: 20px;'> Agregado</span>",
              html:
                "<span style='font-size: 12px;'>Invitado agregado correctamente</span>",
              type: "success",
              width: "30%",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept"
              },
              onClose: () => {
                document
                  .getElementById("form1")
                  .classList.remove("was-validated");
                document
                  .getElementById("invitedFirstName")
                  .classList.remove("form-control");
                document
                  .getElementById("invitedLastName")
                  .classList.remove("form-control");
              }
            });
          }
        });
      }
    },
    pushData() {
      this.invitedModel = {
        uuid: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
      };
    },
    handleFileEvent(event, invitedEdit = {}) {
      this.isLoading = true;
      // Determinar los archivos del evento (drop o change)
      const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
      // Validar si hay archivos
      if (!files?.length) {
        this.isLoading = false;
        return this.showMessageError("No se seleccionó ningún archivo.", "Selecciona un archivo de hoja de cálculo");
      }
      const file = files[0];
      const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-excel", // .xls
        "text/csv", // .csv
        "application/vnd.oasis.opendocument.spreadsheet", // .ods (LibreOffice Calc)
      ];
      if (!allowedTypes.includes(file.type)) {
        this.isLoading = false;
        return this.showMessageError("El tipo de archivo es incorrecto", "Selecciona un archivo de hoja de cálculo válido");
      }
      // Lógica para el escenario con o sin edición de invitado
      if (Object.keys(invitedEdit).length === 0) {
        this.convertExcelToJSON(file); // Escenario general
      } else {
        this.handleGuestEdit(event, invitedEdit, file); // Escenario con edición de invitado
      }
    },
    // Función para manejar el caso de edición de invitado
    handleGuestEdit(event, invitedEdit, file) {
      event.preventDefault();
      const invitedIndex = this.guestList.findIndex(
        guest => 
          guest.email.trim() === invitedEdit.email.trim() &&
          guest.firstName.trim() === invitedEdit.firstName.trim() &&
          guest.lastName.trim() === invitedEdit.lastName.trim()
      );
      if (invitedIndex === -1) {
        this.isLoading = false;
        return this.showMessageError("Invitado no encontrado.", "Por favor verifica los datos del invitado.");
      }
      // Asignar archivo al invitado
      this.guestList[invitedIndex].file = file;
      this.convertExcelToJSON(file, invitedIndex); // Procesar archivo para el invitado específico
    },
    convertExcelToJSON: function(fileList, invitedIndex = null) {
      const reader = new FileReader();
      const processExcelFile = (jsonData) => {
        const firstRecord = jsonData[0] || [];
        const dataToValidate = invitedIndex === null ? jsonData : [firstRecord];
        if (invitedIndex === null) {
          this.excel2json = jsonData;
          this.validateExcel(this.excel2json);
        } else {
          this.excel2json = dataToValidate;
          this.validateExcel(this.excel2json, invitedIndex, jsonData.length);
        }
      };
      reader.onload = (e) => {
        const data = new Uint8Array(reader.result);
        const bstr = String.fromCharCode.apply(null, data);  // Se optimiza la conversión de bytes a string
        const workbook = XLSX.read(bstr, { type: "binary" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const expectedColumns = ['Nombre', 'Apellidos', 'Teléfono', 'Correo Electrónico'];
        // Convertir hoja a JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          defval: "" // Esto asegura que las celdas vacías se llenen con una cadena vacía
        });
        // Obtener los nombres de las columnas en el primer objeto del JSON (supone que todas las filas tienen las mismas columnas)
        const columnNames = Object.keys(jsonData[0]);

        // Verificar si los nombres de las columnas coinciden con los esperados
        const missingColumns = expectedColumns.filter(col => !columnNames.includes(col));
        const extraColumns = columnNames.filter(col => !expectedColumns.includes(col));

        let errorMessage = "";

        // Acumular los mensajes de error
        if (missingColumns.length > 0) {
          errorMessage += `Faltan las siguientes columnas: ${missingColumns.join(", ")}. `;
        }

        if (extraColumns.length > 0) {
          errorMessage += `Existen columnas adicionales: ${extraColumns.join(", ")}. `;
        }

        // Si hay algún error, mostrar el mensaje y devolver
        if (errorMessage) {
          this.isLoading = false;
          this.showMessageError("Error al agregar la lista de invitados", errorMessage.trim());
          return; // Salir de la función si hay errores
        }
        processExcelFile(jsonData);  // Llamar a la función auxiliar
      };
      reader.readAsArrayBuffer(fileList);
    },
    validateExcel: function(val, invitedIndex = null, dataLenght = 0) {
      const validateKeys = (val) => {
        const requiredKeys = ["Nombre", "Apellidos", "Teléfono", "Correo Electrónico"];
        const result = requiredKeys.every((key, index) => {
          return val[index] === key;
        });
        return result;
      };
      const processGuestData = (val, guestList, guestNew, guestDuplicate) => {
        val.forEach((row, index) => {
          this.invitedModel.firstName = row.Nombre;
          this.invitedModel.lastName = row.Apellidos;
          this.invitedModel.phone = row["Teléfono"];
          this.invitedModel.email = row["Correo Electrónico"];
          if (!this.validateRowExcel(index + 1)) {
            return;
          }
          const found = guestList.find(
            (element) =>
              element.firstName === this.invitedModel.firstName &&
              element.lastName === this.invitedModel.lastName
          );
          if (found === undefined) {
            guestNew.push(this.invitedModel);
          } else {
            guestDuplicate.push(this.invitedModel);
          }
          this.invitedModel = { uuid: "", firstName: "", lastName: "", email: "", phone: "" };
        });
      };
      const handleErrors = () => {
        this.isLoading = false;
        const errorMessage =
          this.errorsOnFileList.length > 4
            ? `Hay varios errores en los datos, se enlistan los primeros 4:${this.errorsOnFileList.slice(0, 4).join(" ")}`
            : `${this.errorsOnFileList.join(" ")}`;

        this.showMessageError("Error al agregar la lista de invitados", errorMessage);
        this.errorsOnFileList = [];
      };
      const showSuccessMessage = (guestNew) => {
        let detectadoTexto = guestNew.length === 1 ? "Se detectó" : "Se detectaron";
        let invitadosTexto = guestNew.length === 1 ? "invitado nuevo" : "invitados nuevos";
        let contenidoHtml = `<div>${detectadoTexto}: <p>${guestNew.length} ${invitadosTexto} en el archivo</p></div>`;
        this.isLoading = false;
        Swal.fire({
          title: "<span style='font-size: 20px;'> El formato es correcto</span>",
          html: contenidoHtml,
          type: "success",
          width: "30%",
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn-modal-accept"
          },
          showConfirmButton: true,
          onClose: () => {
            this.residentsFile = "";
            const input = this.$refs.fileupload;
            input.type = "text";
            input.type = "file";
          }
        });
      };

      if (!invitedIndex && dataLenght === 0) {
        this.excel2jsonFail = [];
        const keys = Object.keys(val[0]);
        if (!validateKeys(keys)) {
          this.isLoading = false;
          this.showMessageError("El formato es incorrecto", "Selecciona un archivo de hoja de cálculo");
          return;
        }

        if (val.length > 0) {
          this.residentsFile = "";
          const input = this.$refs.fileupload;
          input.type = "text";
          input.type = "file";
          this.activeSession = true;

          let guestNew = [];
          let guestDuplicate = [];
          let hasErrors = false;

          processGuestData(val, this.guestList, guestNew, guestDuplicate);

          if (this.errorsOnFileList.length > 0) {
            handleErrors();
            return;
          }

          showSuccessMessage(guestNew);

          if (guestDuplicate.length > 0) {
            Swal.fire({
              title: "<span style='font-size: 20px;'>¿Estás seguro de agregarlo(s) nuevamente?</span>",
              html: `<span style='font-size: 12px;'>Hemos detectado ${guestDuplicate.length} invitado(s) duplicado(s)</span>`,
              type: "warning",
              showCancelButton: true,
              reverseButtons: true,
              width: "30%",
              confirmButtonText: "Si, agregar",
              cancelButtonText: "Cancelar",
              customClass: {
                confirmButton: "btn-modal-accept",
                cancelButton: "btn-modal-cancel"
              },
              allowOutsideClick: false,
              onAfterClose: () => {
                if (guestNew.length > 0) {
                  if (invitedIndex !== null) {
                    this.guestList[invitedIndex] = guestNew[0];
                    this.dataGuestEdited = guestNew;
                  } else {
                    this.guestList.push(...guestNew);
                    this.pushData();
                  }
                }
              }
            });
          } else if (guestNew.length > 0) {
            if (invitedIndex !== null) {
              this.guestList[invitedIndex] = guestNew[0];
              this.dataGuestEdited = guestNew;
            } else {
              this.guestList.push(...guestNew);
              this.pushData();
            }
          }
        }
      } else {
        // Mismo procesamiento si invitedIndex tiene valor y dataLenght también
        const keys = Object.keys(val[0]);
        if (!validateKeys(keys)) {
          this.isLoading = false;
          this.showMessageError("El formato es incorrecto", "Selecciona un archivo de hoja de cálculo");
          return;
        }

        if (val.length > 0) {
          this.residentsFile = "";
          const input = this.$refs.fileupload;
          input.type = "text";
          input.type = "file";
          this.activeSession = true;

          let guestNew = [];
          let guestDuplicate = [];
          let hasErrors = false;

          processGuestData(val, this.guestList, guestNew, guestDuplicate);

          if (this.errorsOnFileList.length > 0) {
            handleErrors();
            return;
          }

          let aux = JSON.parse(JSON.stringify(this.guestList));
          showSuccessMessage(guestNew);

          if (guestDuplicate.length > 0) {
            Swal.fire({
              title: "<span style='font-size: 20px;'>¿Estás seguro de agregarlo nuevamente?</span>",
              html: "<span style='font-size: 12px;'>Hemos detectado un invitado duplicado</span>",
              type: "warning",
              showCancelButton: true,
              reverseButtons: true,
              width: "30%",
              confirmButtonText: "Si, agregar",
              cancelButtonText: "Cancelar",
              customClass: {
                confirmButton: "btn-modal-accept",
                cancelButton: "btn-modal-cancel"
              },
              allowOutsideClick: false,
              onAfterClose: () => {
                if (guestNew.length > 0) {
                  aux[invitedIndex] = guestNew[0];
                  this.dataGuestEdited = guestNew;
                }
              }
            });
          } else if (guestNew.length > 0) {
            aux[invitedIndex] = guestNew[0];
            this.dataGuestEdited = guestNew;
          }
        }
      }
    },
    getCommonAreas() {
      let aux = this;
      Axios.get(this.urlServer + "api/commonareas/byfrac", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].uuid,
              text: response.data[i].name
            };
            aux.commonAreas.push(temp);
          }
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error);
        });
    },
    getResidents() {
      let aux = this;
      Axios.get(this.urlServer + "api/residents/all", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].uuid,
              text: response.data[i].firstName + " " + response.data[i].lastName
            };
            aux.residentsList.push(temp);
          }
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error);
        });
    },
    getOneResident() {
      let aux = this;
      Axios.get(this.urlServer + "api/residents/findOne", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.resident = response.data;
          aux.residentModel.value = response.data.uuid;
          aux.residentModel.text =
            response.data.firstName + " " + response.data.lastName;
          aux.residentsList.push(aux.residentModel);
          aux.userValid = false;
          var temp = {
            value: null,
            text: aux.resident.testStreet.name + " #" + aux.resident.number
          };
          aux.commonAreas.push(temp);
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error);
        });
    },
    checkSession() {
          this.isAdmin = localStorage.getItem("isAdmin")
          // console.log(this.isAdmin);

          if (this.isAdmin) {
            this.getResidents();
            var temp = {
              value: null,
              text: "Casa del residente"
            };
            this.commonAreas.push(temp);
          } else {
            this.getOneResident();
          }
    },
    showMessageError: function(text, error, customClass) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../../../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept",
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>Correcto</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        }
      });
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    countdown() {
      this.remainingCount = this.maxCount - this.description.length;
    },
    getOneEvent(uuid) {
      let aux = this;
      return Axios.get(this.urlServer + "api/massiveEvents/" + uuid, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(response => {
          aux.eventoRespaldo = response.data;
          aux.guestList = [];
          var offset = new Date().getTimezoneOffset() * 60000;
          aux.form[0].title = aux.eventoRespaldo.title;
          var dateaux = new Date(aux.eventoRespaldo.startDate);
          aux.form[0].datepicker = new Date(dateaux - offset)
            .toISOString()
            .split("T")[0];
          aux.form[0].timepicker = new Date(aux.eventoRespaldo.startDate)
            .toTimeString()
            .split(" ")[0];
          document.getElementById("timePicker").value = new Date(
            aux.eventoRespaldo.startDate
          )
            .toTimeString()
            .split(" ")[0];
          aux.description = aux.eventoRespaldo.additionalInformation;
          aux.residentModel.value = aux.eventoRespaldo.resident.uuid;
          aux.residentModel.text =
            aux.eventoRespaldo.resident.firstName +
            " " +
            aux.eventoRespaldo.resident.lastName;
          aux.resident = aux.eventoRespaldo.resident;
          if (aux.eventoRespaldo.commonArea === null) {
            if (aux.isAdmin) {
              aux.placeModel.value = null;
              aux.placeModel.text = "Casa del residente";
            } else {
              aux.placeModel.value = null;
              aux.placeModel.text =
                aux.eventoRespaldo.resident.testStreet.name +
                " #" +
                aux.eventoRespaldo.resident.number;
            }
          } else {
            aux.placeModel.value = aux.eventoRespaldo.commonArea.uuid;
            aux.placeModel.text = aux.eventoRespaldo.commonArea.name;
          }
          aux.eventoRespaldo.massiveEventGuests.map(function(value, key) {
            aux.invitedModel.uuid = value.uuid;
            aux.invitedModel.firstName = value.firstName;
            aux.invitedModel.lastName = value.lastName;
            aux.invitedModel.phone = value.phone;
            aux.invitedModel.email = value.email;
            aux.guestList.push(aux.invitedModel);
            aux.pushData();
          });
          if (aux.eventoRespaldo.backgroundColor != null) {
            aux.colorFront = "#"+aux.eventoRespaldo.backgroundColor;
          }
          if (aux.eventoRespaldo.foregroundColor != null) {
            aux.colorText = "#"+aux.eventoRespaldo.foregroundColor;
          }

          if (aux.eventoRespaldo.backgroundImage != null) {
            aux.urlFile = aux.eventoRespaldo.backgroundImage.publicUrl;
            aux.uuidFile = aux.eventoRespaldo.backgroundImage.uuid;
          }

          if (aux.eventoRespaldo.profile != null) {
            aux.urlAvatar = aux.eventoRespaldo.profile.publicUrl;
            aux.uuidAvatar = aux.eventoRespaldo.profile.uuid;
          }
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error);
        });
    },
    addMultipleGuest(guests) {
      let aux = this;
      var data = {
        massiveEvent: {
          uuid: aux.massiveEvents
        },
        guests: guests
      };
      Axios.post(this.urlServer + "api/massiveEventGuests/multiple", data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.nuevosInvitados = response.data;
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error en addMultipleGuest", error);
        });
    },
    updateGuest(guests, uuidEvent) {
      let aux = this;
      guests.map(function(value, key) {
        var data = {
          uuid: value.uuid,
          firstName: value.firstName,
          lastName: value.lastName,
          email: value.email,
          phone: value.phone,
          massiveEvent: {
            uuid: uuidEvent
          }
        };
        Axios.put(
          aux.urlServer + "api/massiveEventGuests/" + value.uuid,
          data,
          {
            responseType: "application/json",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token")
            }
          }
        )
          .then(function(response) {})
          .catch(error => {
            aux.showMessageError("Ha ocurrido un error", error);
          });
      });
    },
    deleteGuest(guest) {
      Axios.delete(this.urlServer + "api/massiveEventGuests/" + guest, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {})
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error);
        });
    },
    redoEvent() {
      let aux = this;
      aux.guestList = [];
      var offset = new Date().getTimezoneOffset() * 60000;
      aux.form[0].title = aux.eventoRespaldo.title;
      var dateaux = new Date(aux.eventoRespaldo.startDate);
      aux.form[0].datepicker = new Date(dateaux - offset)
        .toISOString()
        .split("T")[0];
      aux.form[0].timepicker = new Date(aux.eventoRespaldo.startDate)
        .toTimeString()
        .split(" ")[0];
      document.getElementById("timePicker").value = new Date(
        aux.eventoRespaldo.startDate
      )
        .toTimeString()
        .split(" ")[0];
      aux.description = aux.eventoRespaldo.additionalInformation;
      aux.residentModel.value = aux.eventoRespaldo.resident.uuid;
      aux.residentModel.text =
        aux.eventoRespaldo.resident.firstName +
        " " +
        aux.eventoRespaldo.resident.lastName;
      aux.resident = aux.eventoRespaldo.resident;
      if (aux.eventoRespaldo.commonArea === null) {
        if (aux.isAdmin) {
          aux.placeModel.value = null;
          aux.placeModel.text = "Casa del residente";
        } else {
          aux.placeModel.value = null;
          aux.placeModel.text =
            aux.eventoRespaldo.resident.testStreet.name +
            " #" +
            aux.eventoRespaldo.resident.number;
        }
      } else {
        aux.placeModel.value = aux.eventoRespaldo.commonArea.uuid;
        aux.placeModel.text = aux.eventoRespaldo.commonArea.name;
      }
      aux.eventoRespaldo.massiveEventGuests.map(function(value, key) {
        aux.invitedModel.uuid = value.uuid;
        aux.invitedModel.firstName = value.firstName;
        aux.invitedModel.lastName = value.lastName;
        aux.invitedModel.phone = value.phone;
        aux.invitedModel.email = value.email;
        aux.guestList.push(aux.invitedModel);
        aux.pushData();
      });
      if (aux.eventoRespaldo.backgroundColor != null) {
        aux.colorFront = "#"+aux.eventoRespaldo.backgroundColor;
      }
      if (aux.eventoRespaldo.foregroundColor != null) {
        aux.colorText = "#"+aux.eventoRespaldo.foregroundColor;
      }

      if (aux.eventoRespaldo.backgroundImage != null) {
        aux.urlFile = aux.eventoRespaldo.backgroundImage.publicUrl;
        aux.uuidFile = aux.eventoRespaldo.backgroundImage.uuid;
      }

      if (aux.eventoRespaldo.profile != null) {
        aux.urlAvatar = aux.eventoRespaldo.profile.publicUrl;
        aux.uuidAvatar = aux.eventoRespaldo.profile.uuid;
      }

      aux.updateEvent();
    },
    validateRowExcel(i){
      var re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      let lineDataError= [`<br>Error en la fila ${i}: `]
      if (!this.invitedModel.firstName || this.invitedModel.firstName === ""){
        lineDataError.push(`el campo 'Nombre' está vacío`);
      }
      if (!this.invitedModel.lastName || this.invitedModel.lastName === ""){
        lineDataError.push(`el campo 'Apellido(s)' está vacío`);
      }
      if (!this.invitedModel.email || this.invitedModel.email === ""){
        lineDataError.push(`el campo 'Correo electrónico' está vacío`);
      } else if (this.invitedModel.email != "" && !re.test(this.invitedModel.email)){
        lineDataError.push(`el campo 'Correo electrónico' no tiene un email: ${this.invitedModel.email}`);
      }
      if (lineDataError.length ===1 ){
        return true;
      } else if (lineDataError.length ===2) {
        let errorInText = lineDataError.slice(0, 1) + lineDataError.slice(-1);
        this.errorsOnFileList.push(errorInText + '.');
        return false;
      } else {
        let errorInText = lineDataError.slice(0, -1).join(', ') + ' y ' + lineDataError.slice(-1);
        this.errorsOnFileList.push(errorInText + '.');
        return false;
      }
    }
  },
  created() {
    let aux = this;
    this.access_token = localStorage.getItem("access_token");
    var currentDate = new Date();
    var offset = new Date().getTimezoneOffset() * 60000;
    this.limitDate[0].from = new Date(new Date() - offset)
      .toISOString()
      .split("T")[0];
    this.form[0].timepicker = currentDate.toTimeString().split(" ")[0];
    this.checkSession();
    this.getCommonAreas();
    //console.log(this.$data);
  },
  mounted() {
    document.getElementById(
      "timePicker"
    ).value = new Date().toTimeString().split(" ")[0];
    // document.getElementById("timePicker").setAttribute("readonly", true);
    // document.getElementById("eventDatePicker").setAttribute("readonly", true);
    if (this.$route.query.token != undefined) {
      this.massiveEvents = this.$route.query.token;
      this.getOneEvent(this.$route.query.token);
    }
  },
  update() {},
  watch: {
    placeModel(newPlace) {
      this.placeModel = newPlace;
      if (newPlace.value || newPlace.text !== "") {
        this.placeValid = false;
      } else {
        this.placeValid = true;
      }
    },
    residentModel(newResident) {
      this.residentModel = newResident;
      if (newResident.value) {
        this.userValid = false;
      } else {
        this.userValid = true;
      }
    },
    // Observar cambios en dataGuestEdited
    'dataGuestEdited': function(newValue) {
      if (newValue !== undefined && newValue !== null && newValue.length > 0) {
        // Asignar los valores de dataGuestEdited a invitedEdit
        this.invitedEdit.firstName = newValue[0].firstName || "";
        this.invitedEdit.lastName = newValue[0].lastName || "";
        this.invitedEdit.email = newValue[0].email || "";
        this.invitedEdit.phone = newValue[0].phone || "";
      }
    },
  },
  computed: {
    titleSection(){
      if (this.$route.query.token != undefined) {
        return "Editar evento masivo"
      } else {
        return "Crear evento masivo"
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.card-person-width{
  max-width: 1500px !important;
}

table.table th,
table.table td {
  padding-top: 0.5rem;
  padding-bottom: 0rem;
}

.btn.btn-edit {
  padding: 0.2rem 0.4rem;
  font-size: 0.64rem;
  border-radius: 7px;
  width: 24px;
  height: 23p;
}

.form-csv {
  height: 170px;
  width: 300px;
  margin: 0 auto;
  border-radius: 2px;
  border: 1px solid #e8e9ec;
  background-color: #ffffff;
}

.form-csv h5,
.form-csv h6 {
  width: 100%;
  color: #545871;
}

.form-csv input {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100px;
  outline: none;
  opacity: 0;
}

.form-csv input:hover {
  cursor: pointer;
}

.form-csv:hover {
  opacity: 0.7;
  border: 4px dashed #676d6d;
}

.Rectangle-536 {
  width: 100%; 
  height: 37px;
  padding: 0.5rem; 
  font-size: 14px;
  border-radius: 4px; 
  border: 1px solid #e8e9ec; 
  background-color: #ffffff;
  box-sizing: border-box;
}

.Rectngulo-1673 {
  width: 161.6px !important;
  height: 37px !important;
  border-radius: 3px !important;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-650 {
  width: 1112.7px;
  height: 500.8px;
  border-radius: 25px;
  border: solid 2px #bce0fd;
  background-color: #ffffff;
}

.save-btn {
  font-size: 10px;
  float: right;
}

.text-width {
  width: auto;
}

.text-input-2 {
  width: auto;
}

.avatar-width {
  width: 4rem !important;
  height: 4rem !important;
  margin-top: -3rem !important;
  margin-left: 0% !important;
}

.qrcode-class {
  width: 114px;
  height: 114px;
  z-index: 1;
  position: absolute;
  margin-left: 38% !important;
  margin-top: 30% !important;
}

.card-body-width {
  width: auto;
  height: 472px;
}
.ui.dropdown .menu > .item {
  font-size: 12px !important;
}

.testimonial-card .avatar img {
  width: 100% !important;
  height: 100% !important;
}

.Rect-BG {
  width: 112%;
  height: 44px;
  background-color: #67a3cf;
  margin-left: -6%;
  margin-bottom: 20px;
  margin-top: -20px;
}

.style_BTN {
  width: 31.2px;
  object-fit: contain;
}

.testimonial-card .avatar {
  border: 0px solid #fff !important;
}

.image-upload > input {
  display: none;
}

.image-upload img {
  width: 15px;
  cursor: pointer;
  z-index: 1;
  margin-left: 5rem;
  margin-top: -4rem;
}

.image-upload2 > input {
  display: none;
}

.image-upload2 img {
  width: 15px;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  float: right;
  /*margin-top: 9rem;*/
  margin-left: 29rem;
  margin-top: 0rem;
}

.header-card-img img {
  width: 100% !important;
  height: auto;
  margin-right: auto !important;
  margin-left: auto !important;
  left: 0 !important;
  right: 0 !important;
}

@media screen and (min-width: 320px) {
  .qrcode-class {
    margin-top: 50% !important;
    margin-left: 30% !important;
  }

  .image-upload2 img {
    margin-left: 14rem;
  }
}

@media screen and (min-width: 375px) {
  .text-width {
    width: 100%;
  }

  .image-upload2 img {
    margin-left: 17rem;
  }

  .qrcode-class {
    margin-top: 33% !important;
    margin-left: 33% !important;
  }

  .text-input-2 {
    width: 270px !important;
  }
}

@media screen and (min-width: 425px) {
  .image-upload2 img {
    margin-left: 20rem;
  }
}

@media screen and (min-width: 768px) {
  .text-width {
    width: 170%;
  }

  .image-upload2 img {
    margin-left: 40rem;
  }

  .qrcode-class {
    margin-top: 20% !important;
    margin-left: 42% !important;
  }

  .text-input-2 {
    width: 270px !important;
  }

  .image-upload img {
    margin-left: 3.6rem;
    margin-top: -4rem;
  }

  .my-custom-row .form-group {
    width: 100%;
  }
}

@media screen and (min-width: 1024px) {
  .text-input-2 {
    width: 360px !important;
  }

  .image-upload2 img {
    margin-left: 28rem;
  }

  .Rectngulo-650 {
    right: 10px;
  }

  .responsive-col {
    margin-top: -18rem;
  }

  .qrcode-class {
    margin-top: 27% !important;
    margin-left: 38% !important;
  }

  .picker-input-responsive {
    -webkit-box-flex: 0 !important;
    flex: 0 0 25% !important;
    max-width: 25% !important;
  }

  .avatar-width {
    margin-left: -15% !important;
  }
}

@media screen and (min-width: 1440px) {
  .text-input-2 {
    width: 460px !important;
  }

  .qrcode-class {
    margin-top: 25% !important;
    margin-left: 38% !important;
  }

  .avatar-width {
    margin-left: 0% !important;
  }

  .image-upload2 img {
    margin-left: 34rem;
  }
}

@media screen and (min-width: 1600px) {
  .qrcode-class {
    margin-top: 15% !important;
    margin-left: 44% !important;
  }

  .avatar-width {
    margin-left: 25% !important;
  }

  .image-upload2 img {
    margin-left: 95%;
  }

  .text-width {
    width: 160%;
  }

}

.verte  button {
  border: 1px solid #000;
  border-radius: 100px;
}

.my-custom-row {
  gap: 1rem;
  justify-content: center;
}

.my-custom-row .form-group {
  width: 100%;
}

label {
  margin-bottom: 0.5rem; /* Espaciado entre el label y el input */
  display: block; /* Hace que el label ocupe toda la línea */
}

/* ---inicia---- SPINNER de 'cargando....'*/
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1031;
}

.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #4c51bf; /* Color del spinner */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* ---termina---- SPINNER de 'cargando....'*/

</style>

